<template>
  <div class="home">
    <div class="_container">
      <div class="home-banner">
        <img src="../assets/image/download/main-KV.png" alt="" />
      </div>
      <div class="main">
        <div class="page-center">
          <div class="main-fix">
            <div class="app-qrcode">
              <div class="qrcode-wrap" v-if="downLink.IOS">
                <div class="app-icon">
                  <img src="../assets/image/download/apple-logo.png" alt="" />
                </div>
                <div class="app-text">
                  <h5>{{ $t("ios_app") }}</h5>
                  <p>{{ $t("scan_qrcode_below") }}</p>
                </div>
                <div class="qrcode-img">
                  <vue-qr :text="downLink.IOS.url" :size="210" :margin="0"></vue-qr>
                </div>
              </div>
              <div class="qrcode-wrap" v-if="downLink.Android">
                <div class="app-icon">
                  <img src="../assets/image/download/android-logo.png" alt="" />
                </div>
                <div class="app-text">
                  <h5>{{ $t("android_app") }}</h5>
                  <p>{{ $t("scan_qrcode_below") }}</p>
                </div>
                <div class="qrcode-img">
                  <vue-qr :text="downLink.Android.url" :size="210" :margin="0"></vue-qr>
                </div>
              </div>
              <div class="qrcode-wrap" v-if="downLink.MOBILECONFIG">
                <div class="app-icon">
                  <img src="../assets/image/download/icon-logo.png" alt="" />
                </div>
                <div class="app-text">
                  <h5>{{ $t("ios_lite_app") }}</h5>
                  <p>{{ $t("scan_qrcode_below") }}</p>
                </div>
                <div class="qrcode-img">
                  <vue-qr :text="downLink.MOBILECONFIG.url" :size="210" :margin="0"></vue-qr>
                </div>
              </div>
            </div>
          </div>
          <div class="ios-install">
            <div class="download-notes">
              <div class="ios-title">
                <img src="../assets/image/download/ios-title.png" alt="" />
              </div>
              <div class="install-text">
                <p>{{ $t("local_after_install") }}</p>
              </div>
              <div class="mobile-cut">
                <img src="../assets/image/download/mobile-img.png" alt="" />
              </div>
            </div>
            <div class="notes-img">
              <img src="../assets/image/download/down-notes.png" alt="" />
            </div>
          </div>
          <div class="footer">
            <p>{{ $t("local_please_add_favorite") }}</p>
            <p>Copyright © 2021 TCGLIVE</p>
          </div>
        </div>
      </div>
    </div>
    <FloatService />
  </div>
</template>

<script>
import { isMobile } from "../utils/utils";
import VueQr from "@/components/vueQr";
import FloatService from "@/components/FloatService/FloatService";
export default {
  components: {
    VueQr,
    FloatService,
  },
  data() {
    return {
      active: "register",
      showModal: false,
      appType: "",
    };
  },
  computed: {
    downLink() {
      return this.$store.state.downLink;
    },
  },
  methods: {
    tabChange(tab) {
      this.active = tab;
    },
    openLink(url) {
      window.open(url, "_blank");
    },
    closeAppModal() {
      this.showModal = false;
    },
    getStatus() {
      let data = {
        device: "WEB",
      };
      this.$store.dispatch("getStatus", data);
    },
    downApp(link) {
      if (link) {
        let a = document.createElement("a");
        a.href = link;
        a.click();
      }
    },
    downAndroid() {
      let link = this.downLink["Android"]["url"];
      if (!isMobile()) {
        if (link) {
          this.appType = "android";
          this.showModal = true;
        }
      } else {
        this.downApp(link);
      }
    },
    downIos() {
      let link = this.downLink["MOBILECONFIG"]["url"];
      if (!isMobile()) {
        if (link) {
          this.appType = "ios";
          this.showModal = true;
        }
      } else {
        this.downApp(link);
      }
    },
    showAlert() {
      this.$loading.show();
    },
  },
  created() {
    this.getStatus();
  },
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  background-color: #efeef3;
  ._container {
    width: 100%;
    height: 100%;
    position: relative;
    .home-banner {
      img {
        display: block;
        width: 100%;
      }
    }
  }
  .main {
    width: 100%;
    margin: 0 auto;
    background-image: url("../assets/image/download/body-bubble-bg.png");
    background-size: 100% auto;
    .main-fix {
      width: 100%;
      height: 304px;
      position: relative;
    }
    .app-qrcode {
      width: 100%;
      position: absolute;
      left: 0;
      top: -100px;
      display: flex;
      justify-content: center;
      .qrcode-wrap {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 250px;
        height: 404px;
        margin: 0 69px;
        padding-top: 20px;
        background-color: #8d1ef1;
        box-shadow: 0px 5px 0px 0px #4b008f;
        border-radius: 10px;
      }
      .qrcode-img {
        width: 220px;
        height: 220px;
        margin-top: 20px;
        padding: 5px;
        background-color: #fff;
      }
      .app-text {
        h5 {
          font-size: 20px;
          color: #fff;
          font-weight: normal;
          margin-top: 15px;
          text-align: center;
        }
        p {
          margin-top: 5px;
          font-size: 14px;
          color: #c892ff;
          text-align: center;
        }
      }
    }
    .ios-install {
      margin-top: 80px;
      display: flex;
      justify-content: space-between;
    }
    .download-notes {
      padding-left: 40px;
      padding-top: 50px;
      flex: 1;
      .title {
        font-size: 38px;
        color: #b6b6b6;
      }
      .ios-title {
        margin-top: 40px;
      }
    }
    .install-text {
      margin-top: 26px;
      font-size: 16px;
      color: #333;
    }
    .mobile-cut {
      position: relative;
      width: 100%;
      margin-top: 50px;
      img {
        position: absolute;
        left: -180px;
        top: 0;
      }
    }
  }
  .footer {
    padding: 40px 20px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    font-size: 16px;
    color: #b6b6b6;
  }
}
</style>
